
import { LoaderService } from './layout/shared/loader.service';
import { AuthService } from './authentication/auth.service';
import {
  Router,
  // import as RouterEvent to avoid confusion with the DOM Event
  Event as RouterEvent,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError
} from '@angular/router'
import { NgZone, Component, ViewEncapsulation } from '@angular/core'
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  //styleUrls: ['./app.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent {
  
  constructor(private router: Router, private ngZone: NgZone, 
    private LoaderService: LoaderService,private authService:AuthService) {
    router.events.subscribe((event: RouterEvent) => {
      this._navigationInterceptor(event);
    });   
  }
  ngOnInit() {
    
    // if (window.location.hash && window.location.hash.indexOf('#/') !== 0 && this.securityService.IsTokenExpired(null) == false) {
    //   this.securityService.authorizeCallback();
    // } else if (!this.securityService.IsAuthorized) {
    //   this.securityService.authorize();
    // } else {
    
    // }
  }
  
  // Shows and hides the loading spinner during RouterEvent changes
  private _navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      this.ngZone.runOutsideAngular(() => {
       this.LoaderService.start();
      });
    }
    if (event instanceof NavigationEnd) {
      this._hideSpinner();
    }
    if (event instanceof NavigationCancel) {
      this._hideSpinner();
    }
    if (event instanceof NavigationError) {
      this._hideSpinner();
    }
  }
  private _hideSpinner(): void {
    this.ngZone.runOutsideAngular(() => {
      this.LoaderService.stop();
    });
  }

}